"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vault = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var Buffer = require('buffer/').Buffer;
var bs58_1 = __importDefault(require("bs58"));
var wallet_1 = require("./wallet");
var address_1 = require("./address");
var utils_1 = require("./utils");
var Vault = /** @class */ (function () {
    function Vault(_a) {
        var sodium = _a.sodium, wallet = _a.wallet, username = _a.username, identity = _a.identity, localPassword = _a.localPassword, remotePassword = _a.remotePassword, localShare = _a.localShare, boxedRemoteShare = _a.boxedRemoteShare, verificationKey = _a.verificationKey, emergencyKey = _a.emergencyKey, remoteEmergencyData = _a.remoteEmergencyData, recoveryOTP = _a.recoveryOTP;
        this.sodium = sodium;
        this.wallet = wallet;
        this.username = username;
        this.identity = identity;
        this.localPassword = localPassword;
        this.remotePassword = remotePassword;
        this.localShare = localShare;
        this.boxedRemoteShare = boxedRemoteShare;
        this.verificationKey = verificationKey;
        this.emergencyKey = emergencyKey;
        this.remoteEmergencyData = remoteEmergencyData;
        this.recoveryOTP = recoveryOTP;
    }
    Vault.create = function (_a) {
        var username = _a.username, password = _a.password, mnemonic = _a.mnemonic;
        return __awaiter(this, void 0, void 0, function () {
            var wallet, shares, passwordShares, identity, verificationKey, boxedRemoteShare, emergencyKey, remoteEmergencyData, sodium;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, wallet_1.Wallet.create({
                            mnemonic: mnemonic,
                        })
                        // Create backup shares
                    ];
                    case 1:
                        wallet = _b.sent();
                        shares = wallet.backup({
                            numShares: 3,
                            threshold: 2,
                        });
                        return [4 /*yield*/, Vault.passwordShares(password)
                            // generate identity
                        ];
                    case 2:
                        passwordShares = _b.sent();
                        return [4 /*yield*/, this.getIdentity(username)
                            // generate verification key (for signing challenge code for authorization)
                        ];
                    case 3:
                        identity = _b.sent();
                        return [4 /*yield*/, this.getVerificationKey(wallet)
                            // generate boxed remote share
                        ];
                    case 4:
                        verificationKey = _b.sent();
                        return [4 /*yield*/, this.getBoxedRemoteShare(shares[1], new Uint8Array(bs58_1.default.decode(passwordShares.localPassword)))
                            // generate emergency key
                        ];
                    case 5:
                        boxedRemoteShare = _b.sent();
                        emergencyKey = this.generateEmergencyKey();
                        return [4 /*yield*/, this.getRemoteEmergencyData(username, shares, emergencyKey)];
                    case 6:
                        remoteEmergencyData = _b.sent();
                        return [4 /*yield*/, utils_1.Utilities.libsodium()
                            // create vault
                        ];
                    case 7:
                        sodium = _b.sent();
                        // create vault
                        return [2 /*return*/, new Vault({
                                sodium: sodium,
                                wallet: wallet,
                                username: username,
                                identity: identity,
                                localPassword: passwordShares.localPassword,
                                remotePassword: passwordShares.remotePassword,
                                localShare: shares[0],
                                boxedRemoteShare: boxedRemoteShare,
                                verificationKey: verificationKey,
                                emergencyKey: emergencyKey,
                                remoteEmergencyData: remoteEmergencyData,
                            })];
                }
            });
        });
    };
    Vault.rebuild = function (_a) {
        var username = _a.username, password = _a.password, localShare = _a.localShare, boxedRemoteShare = _a.boxedRemoteShare;
        return __awaiter(this, void 0, void 0, function () {
            var passwordShares, identity, sodium, unboxedRemoteShare, remoteShare, wallet, shares, verificationKey;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Vault.passwordShares(password)
                        // generate identity
                    ];
                    case 1:
                        passwordShares = _b.sent();
                        return [4 /*yield*/, this.getIdentity(username)];
                    case 2:
                        identity = _b.sent();
                        return [4 /*yield*/, utils_1.Utilities.libsodium()
                            // Unbox remote share
                        ];
                    case 3:
                        sodium = _b.sent();
                        unboxedRemoteShare = sodium.crypto_secretbox_open_easy(new Uint8Array(Buffer.from(boxedRemoteShare.split('.')[1], 'base64')), new Uint8Array(Buffer.from(boxedRemoteShare.split('.')[0], 'base64')), new Uint8Array(bs58_1.default.decode(passwordShares.localPassword)));
                        remoteShare = Buffer.from(unboxedRemoteShare).toString('utf-8');
                        return [4 /*yield*/, wallet_1.Wallet.restore(localShare, remoteShare)
                            // create backup shares
                        ];
                    case 4:
                        wallet = _b.sent();
                        shares = wallet.backup({
                            numShares: 3,
                            threshold: 2,
                        });
                        return [4 /*yield*/, this.getVerificationKey(wallet)
                            // create vault
                        ];
                    case 5:
                        verificationKey = _b.sent();
                        // create vault
                        return [2 /*return*/, new Vault({
                                sodium: sodium,
                                wallet: wallet,
                                username: username,
                                identity: identity,
                                localPassword: passwordShares.localPassword,
                                remotePassword: passwordShares.remotePassword,
                                localShare: shares[0],
                                boxedRemoteShare: boxedRemoteShare,
                                verificationKey: verificationKey,
                            })];
                }
            });
        });
    };
    Vault.recover = function (_a) {
        var emergencyKey = _a.emergencyKey, boxedUsername = _a.boxedUsername, password = _a.password, recoveryShares = _a.recoveryShares, recoveryOTP = _a.recoveryOTP;
        return __awaiter(this, void 0, void 0, function () {
            var hash, sodium, key1, key2, key3, unboxedShare, share1, share2, unboxedUsername, username, identity, wallet, shares, verificationKey, passwordShares, boxedRemoteShare, remoteEmergencyData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Vault.deriveKey(emergencyKey, 128)];
                    case 1:
                        hash = _b.sent();
                        return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 2:
                        sodium = _b.sent();
                        key1 = Buffer.from(new ArrayBuffer(32));
                        key2 = Buffer.from(new ArrayBuffer(32));
                        key3 = Buffer.from(new ArrayBuffer(64));
                        hash.copy(key1, 0, 0, 32);
                        hash.copy(key2, 0, 32, 64);
                        hash.copy(key3, 0, 64);
                        unboxedShare = sodium.crypto_secretbox_open_easy(new Uint8Array(Buffer.from(recoveryShares[0].split('.')[1], 'base64')), new Uint8Array(Buffer.from(recoveryShares[0].split('.')[0], 'base64')), new Uint8Array(key1));
                        share1 = Buffer.from(unboxedShare).toString('utf-8');
                        // Unbox emergency share 2
                        unboxedShare = sodium.crypto_secretbox_open_easy(new Uint8Array(Buffer.from(recoveryShares[1].split('.')[1], 'base64')), new Uint8Array(Buffer.from(recoveryShares[1].split('.')[0], 'base64')), new Uint8Array(key2));
                        share2 = Buffer.from(unboxedShare).toString('utf-8');
                        unboxedUsername = sodium.crypto_secretbox_open_easy(new Uint8Array(Buffer.from(boxedUsername.split('.')[1], 'base64')), new Uint8Array(Buffer.from(boxedUsername.split('.')[0], 'base64')), new Uint8Array(key2));
                        username = Buffer.from(unboxedUsername).toString('utf-8');
                        return [4 /*yield*/, this.getIdentity(username)
                            // Restore wallet
                        ];
                    case 3:
                        identity = _b.sent();
                        return [4 /*yield*/, wallet_1.Wallet.restore(share1, share2)
                            // Create backup shares
                        ];
                    case 4:
                        wallet = _b.sent();
                        shares = wallet.backup({
                            numShares: 3,
                            threshold: 2,
                        });
                        return [4 /*yield*/, this.getVerificationKey(wallet)
                            // Generate password shares
                        ];
                    case 5:
                        verificationKey = _b.sent();
                        return [4 /*yield*/, Vault.passwordShares(password)
                            // generate boxed remote share
                        ];
                    case 6:
                        passwordShares = _b.sent();
                        return [4 /*yield*/, this.getBoxedRemoteShare(shares[1], new Uint8Array(bs58_1.default.decode(passwordShares.localPassword)))
                            // generate new emergency key
                        ];
                    case 7:
                        boxedRemoteShare = _b.sent();
                        // generate new emergency key
                        emergencyKey = this.generateEmergencyKey();
                        return [4 /*yield*/, this.getRemoteEmergencyData(username, shares, emergencyKey)
                            // create vault
                        ];
                    case 8:
                        remoteEmergencyData = _b.sent();
                        // create vault
                        return [2 /*return*/, new Vault({
                                sodium: sodium,
                                wallet: wallet,
                                username: username,
                                identity: identity,
                                localPassword: passwordShares.localPassword,
                                remotePassword: passwordShares.remotePassword,
                                localShare: shares[0],
                                boxedRemoteShare: boxedRemoteShare,
                                verificationKey: verificationKey,
                                emergencyKey: emergencyKey,
                                remoteEmergencyData: remoteEmergencyData,
                                recoveryOTP: recoveryOTP,
                            })];
                }
            });
        });
    };
    Vault.passwordShares = function (password) {
        return __awaiter(this, void 0, void 0, function () {
            var hash, remotePassword, localPassword;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Vault.deriveKey(password, 96)];
                    case 1:
                        hash = _a.sent();
                        remotePassword = Buffer.from(new ArrayBuffer(64));
                        localPassword = Buffer.from(new ArrayBuffer(32));
                        hash.copy(remotePassword, 0, 0, 64);
                        hash.copy(localPassword, 0, 64);
                        return [2 /*return*/, {
                                remotePassword: bs58_1.default.encode(remotePassword),
                                localPassword: bs58_1.default.encode(localPassword),
                            }];
                }
            });
        });
    };
    Vault.getIdentity = function (username) {
        return __awaiter(this, void 0, void 0, function () {
            var sodium, identity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _a.sent();
                        identity = sodium.crypto_generichash(64, sodium.crypto_generichash(64, Buffer.from(username)));
                        return [2 /*return*/, bs58_1.default.encode(identity)];
                }
            });
        });
    };
    Vault.getVerificationKey = function (wallet) {
        return __awaiter(this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, wallet.deriveAddress({
                            path: wallet.identity,
                            type: address_1.AddressType.SIGN,
                        })];
                    case 1:
                        address = _a.sent();
                        return [2 /*return*/, Buffer.from(address.publicKey).toString('base64')];
                }
            });
        });
    };
    Vault.getBoxedRemoteShare = function (share, localPassword) {
        return __awaiter(this, void 0, void 0, function () {
            var nonce, message, sodium, boxedData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, address_1.Address.nonce()];
                    case 1:
                        nonce = _a.sent();
                        message = new Uint8Array(Buffer.from(share, 'utf-8'));
                        return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 2:
                        sodium = _a.sent();
                        boxedData = sodium.crypto_secretbox_easy(message, nonce, localPassword);
                        return [2 /*return*/, Buffer.from(nonce).toString('base64') + "." + Buffer.from(boxedData).toString('base64')];
                }
            });
        });
    };
    Vault.getRemoteEmergencyData = function (username, backupShares, emergencyKey) {
        return __awaiter(this, void 0, void 0, function () {
            var sodium, hash, key1, key2, key3, nonce, boxedShare, share1, share2, boxedUsername, remoteBoxedUsername, password, identity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _a.sent();
                        return [4 /*yield*/, Vault.deriveKey(emergencyKey, 128)];
                    case 2:
                        hash = _a.sent();
                        key1 = Buffer.from(new ArrayBuffer(32));
                        key2 = Buffer.from(new ArrayBuffer(32));
                        key3 = Buffer.from(new ArrayBuffer(64));
                        hash.copy(key1, 0, 0, 32);
                        hash.copy(key2, 0, 32, 64);
                        hash.copy(key3, 0, 64);
                        return [4 /*yield*/, address_1.Address.nonce()];
                    case 3:
                        nonce = _a.sent();
                        boxedShare = sodium.crypto_secretbox_easy(Buffer.from(backupShares[1]), nonce, key1);
                        share1 = Buffer.from(nonce).toString('base64') + "." + Buffer.from(boxedShare).toString('base64');
                        return [4 /*yield*/, address_1.Address.nonce()];
                    case 4:
                        // Create emergency share 2
                        nonce = _a.sent();
                        boxedShare = sodium.crypto_secretbox_easy(Buffer.from(backupShares[2]), nonce, key2);
                        share2 = Buffer.from(nonce).toString('base64') + "." + Buffer.from(boxedShare).toString('base64');
                        return [4 /*yield*/, address_1.Address.nonce()];
                    case 5:
                        // Create boxed username
                        nonce = _a.sent();
                        boxedUsername = sodium.crypto_secretbox_easy(Buffer.from(username), nonce, key2);
                        remoteBoxedUsername = Buffer.from(nonce).toString('base64') + "." + Buffer.from(boxedUsername).toString('base64');
                        password = bs58_1.default.encode(key3);
                        identity = sodium.crypto_generichash(64, sodium.crypto_generichash(64, Buffer.from(emergencyKey)));
                        return [2 /*return*/, {
                                share1: share1,
                                share2: share2,
                                boxedUsername: remoteBoxedUsername,
                                identity: bs58_1.default.encode(identity),
                                password: password,
                            }];
                }
            });
        });
    };
    Vault.generateEmergencyKey = function () {
        var key = utils_1.Utilities.randomString({
            length: 25,
            useLowerCase: false,
        });
        return key.substring(0, 5) + "-" + key.substring(5, 10) + "-" + key.substring(10, 15) + "-" + key.substring(15, 20) + "-" + key.substring(20);
    };
    Vault.deriveKey = function (secret, length) {
        return __awaiter(this, void 0, void 0, function () {
            var sodium, derivedKey1, derivedKey2, derivedKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()
                        // Derive root key from mnemonic
                    ];
                    case 1:
                        sodium = _a.sent();
                        derivedKey1 = sodium.crypto_kdf_derive_from_key(64, (2 ^ 32) - 1, 'DERIVKEY', sodium.crypto_generichash(32, Buffer.from(secret, 'utf-8')));
                        derivedKey2 = sodium.crypto_kdf_derive_from_key(64, (2 ^ 32) - 1, 'DERIVKEY', sodium.crypto_generichash(32, Buffer.from(derivedKey1, 'utf-8')));
                        derivedKey = Buffer.concat([derivedKey1, derivedKey2]);
                        return [2 /*return*/, derivedKey.slice(0, length)];
                }
            });
        });
    };
    Vault.prototype.createBoxAddress = function (derivationPath) {
        return __awaiter(this, void 0, void 0, function () {
            var path, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = derivationPath || utils_1.Utilities.uniqueId();
                        return [4 /*yield*/, this.wallet.deriveAddress({
                                path: path,
                                type: address_1.AddressType.BOX,
                            })];
                    case 1:
                        address = _a.sent();
                        return [2 /*return*/, address];
                }
            });
        });
    };
    Vault.prototype.createSignAddress = function (derivationPath) {
        return __awaiter(this, void 0, void 0, function () {
            var path, address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        path = derivationPath || utils_1.Utilities.uniqueId();
                        return [4 /*yield*/, this.wallet.deriveAddress({
                                path: path,
                                type: address_1.AddressType.SIGN,
                            })];
                    case 1:
                        address = _a.sent();
                        return [2 /*return*/, address];
                }
            });
        });
    };
    Vault.prototype.signChallenge = function (challenge) {
        return __awaiter(this, void 0, void 0, function () {
            var address, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.wallet.deriveAddress({
                            path: this.wallet.identity,
                            type: address_1.AddressType.SIGN,
                        })];
                    case 1:
                        address = _a.sent();
                        return [4 /*yield*/, address.sign({
                                toBeSigned: new Uint8Array(Buffer.from(challenge, 'utf-8')),
                            })];
                    case 2:
                        signature = _a.sent();
                        return [2 /*return*/, Buffer.from(signature).toString('base64')];
                }
            });
        });
    };
    Vault.prototype.getEmergencyKey = function () {
        // make sure to publish the key just once
        if (!this.emergencyKey)
            return;
        var key = "" + this.emergencyKey;
        this.emergencyKey = undefined;
        return key;
    };
    Vault.prototype.getWallet = function () {
        return this.wallet;
    };
    Vault.prototype.changePassword = function (_a) {
        var oldPassword = _a.oldPassword, newPassword = _a.newPassword;
        return __awaiter(this, void 0, void 0, function () {
            var oldPasswordShares, sodium, unboxedRemoteShare, remoteShare, newPasswordShares, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Vault.passwordShares(oldPassword)];
                    case 1:
                        oldPasswordShares = _c.sent();
                        return [4 /*yield*/, utils_1.Utilities.libsodium()
                            // Unbox remote share
                        ];
                    case 2:
                        sodium = _c.sent();
                        unboxedRemoteShare = sodium.crypto_secretbox_open_easy(new Uint8Array(Buffer.from(this.boxedRemoteShare.split('.')[1], 'base64')), new Uint8Array(Buffer.from(this.boxedRemoteShare.split('.')[0], 'base64')), new Uint8Array(bs58_1.default.decode(oldPasswordShares.localPassword)));
                        remoteShare = Buffer.from(unboxedRemoteShare).toString('utf-8');
                        return [4 /*yield*/, Vault.passwordShares(newPassword)];
                    case 3:
                        newPasswordShares = _c.sent();
                        this.remotePassword = newPasswordShares.remotePassword;
                        _b = this;
                        return [4 /*yield*/, Vault.getBoxedRemoteShare(remoteShare, new Uint8Array(bs58_1.default.decode(newPasswordShares.localPassword)))];
                    case 4:
                        _b.boxedRemoteShare = _c.sent();
                        return [2 /*return*/, true];
                }
            });
        });
    };
    Vault.emergencyCredentials = function (emergencyKey) {
        return __awaiter(this, void 0, void 0, function () {
            var sodium, hash, key1, key2, key3, password, identity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()];
                    case 1:
                        sodium = _a.sent();
                        return [4 /*yield*/, Vault.deriveKey(emergencyKey, 128)];
                    case 2:
                        hash = _a.sent();
                        key1 = Buffer.from(new ArrayBuffer(32));
                        key2 = Buffer.from(new ArrayBuffer(32));
                        key3 = Buffer.from(new ArrayBuffer(64));
                        hash.copy(key1, 0, 0, 32);
                        hash.copy(key2, 0, 32, 64);
                        hash.copy(key3, 0, 64);
                        password = bs58_1.default.encode(key3);
                        identity = sodium.crypto_generichash(64, sodium.crypto_generichash(64, Buffer.from(emergencyKey)));
                        return [2 /*return*/, {
                                identity: bs58_1.default.encode(identity),
                                password: password,
                            }];
                }
            });
        });
    };
    Vault.remoteCredentials = function (_a) {
        var username = _a.username, password = _a.password;
        return __awaiter(this, void 0, void 0, function () {
            var sodium, passwordShares, identity;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, utils_1.Utilities.libsodium()
                        // Generate password shares
                    ];
                    case 1:
                        sodium = _b.sent();
                        return [4 /*yield*/, Vault.passwordShares(password)];
                    case 2:
                        passwordShares = _b.sent();
                        identity = sodium.crypto_generichash(64, sodium.crypto_generichash(64, Buffer.from(username)));
                        return [2 /*return*/, {
                                identity: bs58_1.default.encode(identity),
                                password: passwordShares.remotePassword,
                            }];
                }
            });
        });
    };
    return Vault;
}());
exports.Vault = Vault;
